import { EWasteLocation } from '../../models/e-waste.locations';
import { createContext, FC, useState } from 'react';
import { EWasteLocationSortingFields, Order } from '../../models/types';

interface IEWasteLocationsContext {
  locationsUpdate: boolean;
  toggleLocationsUpdate: () => void;
  locations: EWasteLocation[];
  setLocations: (val: EWasteLocation[]) => void;
  page: number;
  setPage: (val: number) => void;
  limit: number;
  setLimit: (val: number) => void;
  count: number;
  setCount: (val: number) => void;
  order: Order;
  setOrder: (val: Order) => void;
  orderBy: keyof EWasteLocationSortingFields;
  setOrderBy: (val: keyof EWasteLocationSortingFields) => void;
  loading: boolean;
  setLoading: (val: boolean) => void;
}

export const EWasteLocationsContext = createContext<IEWasteLocationsContext>(
  {} as IEWasteLocationsContext
);

export const EWasteLocationsProvider: FC = ({ children }) => {
  // Update
  const [locationsUpdate, setLocationsUpdate] = useState(false);

  // Data
  const [locations, setLocations] = useState<EWasteLocation[]>([]);

  // Pagination props
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(5);
  const [count, setCount] = useState<number>(0);

  // Sorting
  const [order, setOrder] = useState<Order>('desc');
  const [orderBy, setOrderBy] =
    useState<keyof EWasteLocationSortingFields>('createdAt');

  // Loading
  const [loading, setLoading] = useState(false);

  const toggleLocationsUpdate = (): void =>
    setLocationsUpdate(!locationsUpdate);

  return (
    <EWasteLocationsContext.Provider
      value={{
        locationsUpdate,
        toggleLocationsUpdate,
        locations,
        setLocations,
        page,
        setPage,
        limit,
        setLimit,
        count,
        setCount,
        loading,
        setLoading,
        order,
        orderBy,
        setOrder,
        setOrderBy
      }}
    >
      {children}
    </EWasteLocationsContext.Provider>
  );
};
